import { Box, Flex, Heading, Input, VStack } from '@chakra-ui/react';
import React, { useEffect, useCallback } from 'react';
import { getTests, searchTests } from '../../../api/tests';
import useTestStore from '../../../store/testStore';
import { TestCard } from '../../Landing/Tests/TestCard';

export const AllTests = () => {
  const { tests, setTests } = useTestStore();

  React.useEffect(() => {
    import('@lottiefiles/lottie-player');
  }, []);

  const fetchData = useCallback(async () => {
    try {
      const res = await getTests();
      setTests(res);
    } catch (error) {
      console.error('error while loading all tests', error);
    }
  }, [setTests]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearch = async e => {
    e.preventDefault();
    const res = await searchTests(e.target.value);
    setTests(res);
  };

  return (
    <VStack p={[7, 10]} spacing={12}>
      <Flex flexDir={'column'} gap={[5, 9]} alignItems={'center'}>
        <Heading color="teal" fontSize={[24, 30]}>
          Explore All Tests
        </Heading>
        <Input
          variant="outline"
          placeholder="Search For Test"
          size={'lg'}
          width={['80vw', '35vw']}
          onChange={e => handleSearch(e)}
        />
      </Flex>
      <Box
        display="grid"
        gridTemplateColumns={['1fr', '1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}
        gap={[6, 8]}
        width="full"
        justifyContent="center"
      >
        {tests.map((test) => {
          return (
            <Flex key={test._id || test.id} justify="center">
              <TestCard test={test} />
            </Flex>
          );
        })}
      </Box>
    </VStack>
  );
};
